import {
    fetchPrivateFoundationsAsync,
    fetchPrivateFoundationsAsyncBuilder
} from './asyncRequests'
import { IPrivateFoundation } from '../../types'
import { createSlice } from '@reduxjs/toolkit'
import {IPagingResponse} from "../../types/Requests";

export interface PrivateFoundationsInitialState {
    data: IPrivateFoundation[]
    loading: boolean
    success: boolean
    error: string
    paging: IPagingResponse
}

const initialState: PrivateFoundationsInitialState = {
    data: [] as IPrivateFoundation[],
    loading: false,
    success: false,
    error: '',
    paging: {
        totalRows: 0,
        limit: 25,
        skip: 0,
        rows: 0,
        paging: true,
    },
}

export const PrivateFoundationsSlice = createSlice({
    name: 'PrivateFoundationsSlice',
    initialState,
    reducers: {
        setPaging: (state, action) => {
            const {
                limit = state.paging.limit,
                skip = state.paging.skip,
                paging = state.paging.paging,
            } = action.payload

            state.paging = { ...state.paging, skip, limit, paging }
        },
        resetPaging: (state) => {
            state.paging = initialState.paging
        },
        resetPFs: (state) => {
            state.data = initialState.data
        }
    },
    extraReducers: (builder) => {
        fetchPrivateFoundationsAsyncBuilder(builder)
    },
})

export const PrivateFoundationsActions = {
    ...PrivateFoundationsSlice.actions,
    fetchPrivateFoundationsAsync,
}

export const PrivateFoundationsReducer = PrivateFoundationsSlice.reducer